/** Copy shared by more than one Inspector tab. */

/** Under every way of building a net: what a net assumes. */
export const NET_HINT =
  "Assumes one answer per person. For a multi-response question, build an 'any of' variable in the console's Transform."
